<main>
    <div class="content">
        <div class="feedback-form">
            <div class="card">
                <h2>{{ 'feedback.Feedback' | translate }}</h2>
                <div class="row">
                    <div class="col-lg-8 col-md-8 col-sm-8 col-12">
                        <form [formGroup]="createFeedbackForm" (submit)="onSave()">
                            <div class="form-group">
                              <label for="name">{{ 'feedback.Title' | translate }} <span class="required">*</span></label>
                              <input type="text" class="form-control" id="name" placeholder="{{ 'feedback.Enter title' | translate }}" formControlName="name" required>
                            </div>
                            <div class="form-group">
                                <label for="phone_number">{{ 'feedback.Phone' | translate }} <span class="required">*</span></label>
                                <input type="text" class="form-control" id="phone_number" placeholder="{{ 'feedback.Enter phone' | translate }}" pattern="^0\d{8,}$"  maxlength="10" formControlName="phone_number" required>
                            </div>
                            <div class="form-group">
                                <label for="email">{{ 'feedback.Email' | translate }}</label>
                                <input type="text" class="form-control" id="email" placeholder="{{ 'feedback.Enter email' | translate }}" formControlName="email">
                            </div>
                            <div class="form-group">
                                <label for="comment">{{ 'feedback.Comment' | translate }} <span class="required">*</span></label>
                                <textarea class="form-control" id="comment" rows="6" placeholder="{{ 'feedback.Please fill your comment' | translate }}" formControlName="comment" required></textarea>
                            </div>
                            <button *ngIf="currentLanguage === 'en'" type="submit" (click)="showSuccess()" class="btn btn-primary" [disabled]="!createFeedbackForm.valid">{{ 'feedback.Send' | translate }}</button>
                            <button *ngIf="currentLanguage === 'kh'" type="submit" (click)="showSuccessKh()" class="btn btn-primary" [disabled]="!createFeedbackForm.valid">{{ 'feedback.Send' | translate }}</button>
                        </form>
                    </div>
                </div>
              
            </div>
        </div>
        <div class="bottom-content-poster">
            <img src="images/customer_service/customer_service_1.jpg" alt="">
            <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
        </div>
    </div>
</main>
